import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';

export const Title = styled(Typography)`
  text-transform: uppercase;
  text-align: center;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h4};
    margin: 0 ${theme.spacing(2)} ${theme.spacing(2)};
  `}
`;
